module.exports = __webpack_public_path__ + "assets/images/project/constituencies/yio-chu-kang-smc.jpg?v=6585ea1d";